module.exports = __webpack_public_path__ + "static/img/4595_phase_function_Paper_PointsHejduk_Prediction.fee594e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4595_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Sw8S
// module chunks = 0